import React, { useEffect, useState } from 'react';
import { Container, Table, Row, Col, Card, Navbar, Breadcrumb, FormControl, Dropdown } from 'react-bootstrap';
import { useParams, useNavigate, Link, Navigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getNotasCobroFolio } from '../../redux/notascobroFolioSlice';
import { trackPromise, usePromiseTracker } from 'react-promise-tracker';
import LoaderSpinner from '../../libreria/LoaderSpinner';
import { pintaFecha, pintaNumero, pintaPesos, pintaEstado } from '../../libreria/utilidades';
import CardPlaceHolder from '../../componentes/CardPlaceHolder';
import WarningMessage from '../../componentes/WarningMessage';
import SearchIcon from '@mui/icons-material/Search';
import SearchById from '../../componentes/SearchById';
import './NotasCobroFolio.css';

function NotasCobroFolio() {
  const { folio } = useParams();
  const comunidad = useSelector((store) => store.comunidad);
  const notascobro = useSelector((store) => store.notascobroFolio);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { promiseInProgress } = usePromiseTracker({ delay: 0 });

  useEffect(() => {
    const onRender = () => {
      trackPromise(dispatch(getNotasCobroFolio(comunidad.selected.id, folio)));
    };

    onRender();
  }, [comunidad.selected, folio]);

  function handleNotaCobroSearch(value) {
    navigate(`/notacobro/folio/${Number(value)}`);
  }

  return (
    <>
      <Container fluid className='NotasCobroFolio d-flex flex-wrap p-0 shadow-sm'>
        <Navbar bg='white' className='flex-fill border-bottom altura-navbar'>
          <Container fluid className='ms-4'>
            <Breadcrumb className='h4 fw-bold m-0' listProps={{ className: 'm-0' }}>
              <Breadcrumb.Item active className='d-none d-lg-inline text-secondary'>
                Gestión del servicio
              </Breadcrumb.Item>
              <li className='breadcrumb-item d-none d-lg-inline text-primary'>
                <Link to='/notacobro' className='text-decoration-none'>
                  Notas de cobro
                </Link>
              </li>
              <Breadcrumb.Item active>Folio {folio}</Breadcrumb.Item>
            </Breadcrumb>
          </Container>
        </Navbar>
      </Container>
      <Container fluid className='PanelNotasCobro d-flex flex-wrap p-0 shadow-sm'>
        <Navbar bg='warning' className='flex-fill border-bottom altura-navbar'>
          <SearchIcon className='icono-centrado ms-3' />
          <i className='ms-1 fw-bold fst-normal me-1 d-none d-md-inline'>Búsqueda</i>
          <div className='vr mx-2'></div>
          <SearchById className='me-2' placeholder='Folio n.cobr.' btntext='Buscar' onClick={handleNotaCobroSearch} />
        </Navbar>
      </Container>
      <Container fluid>
        <Row className='p-2'>
          <Col xs={12} xl={11} xxl={9} className='p-2'>
            <LoaderSpinner isLoading={promiseInProgress}>
              {notascobro ? (
                <Card className='shadow-sm'>
                  <Card.Header className='bg-light d-flex flex-wrap p-0'>
                    <Navbar className='flex-fill'>
                      <Card.Title className='fs-4 m-0 ms-3 fw-bold'>
                        Nota Cobro Folio: <i className='fst-normal fw-normal'>{folio}</i>
                      </Card.Title>
                    </Navbar>
                  </Card.Header>
                  <Card.Body>
                    <Table striped hover responsive size='sm' className='h6'>
                      <thead>
                        <tr className='text-center'>
                          <th>Período</th>
                          <th>Fecha emisión</th>
                          <th>Fecha vencimiento</th>
                          <th>Lectura [kWh]</th>
                          <th>Consumo [kWh]</th>
                          <th>Folio</th>
                          <th>Estado</th>
                          <th>Monto</th>
                        </tr>
                      </thead>
                      <tbody>
                        {notascobro.rows.map((notacobro) => (
                          <tr key={notacobro.nota_cobro_id}>
                            <td className='text-center'>{notacobro.periodo}</td>
                            <td className='text-center text-nowrap'>{pintaFecha(notacobro.fecha_emision)}</td>
                            <td className='text-center text-nowrap'>{pintaFecha(notacobro.fecha_vencimiento)}</td>
                            <td className='text-end'>{pintaNumero(notacobro.lectura_actual)}</td>
                            <td className='text-end'>{pintaNumero(notacobro.consumo)}</td>
                            <td className='text-end'>
                              <Link className='text-decoration-none' to={`/notacobro/${notacobro.folio}`}>
                                {notacobro.folio}
                              </Link>
                            </td>
                            <td className='text-center'>{pintaEstado(notacobro.estado)}</td>
                            <td className='text-end text-nowrap'>{pintaPesos(parseInt(notacobro.monto_total))}</td>
                          </tr>
                        ))}
                      </tbody>
                    </Table>
                  </Card.Body>
                </Card>
              ) : promiseInProgress ? (
                <CardPlaceHolder />
              ) : (
                <WarningMessage>No se han encontrado notas de cobro para el folio: {folio}.</WarningMessage>
              )}
            </LoaderSpinner>
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default NotasCobroFolio;
